// extracted by mini-css-extract-plugin
module.exports = {"inputArea":"AddTitle_inputArea__1izMt","buttonArea":"AddTitle_buttonArea__Oz3Dj"};